function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.46,0A12.46,12.46,0,1,0,24.91,12.46,12.46,12.46,0,0,0,12.46,0Zm0,24.16a11.71,11.71,0,1,1,11.71-11.7A11.72,11.72,0,0,1,12.46,24.16Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.64,5.27c-3.94.26-6.76,1.56-8.4,3.87-2.17,3.06-1.55,6.9-1.3,8L6.06,19.44a.37.37,0,0,0,.05.52.38.38,0,0,0,.24.09.37.37,0,0,0,.29-.14l1.79-2.18h.2c1.24,0,5.69-.21,7.75-3.08h0c2.45-3.41,2-8,1.85-8.9A.56.56,0,0,0,17.64,5.27Zm-3.3,4h0l-1.55,1.9-.46-3.8a9.89,9.89,0,0,1,1.75-.74Zm.49-2.84A15.28,15.28,0,0,1,17,6.07L15,8.49ZM15,9.65l2.43.11A12.9,12.9,0,0,1,17,11.7l-3.43-.28Zm.59-.72,1.94-2.38a14.68,14.68,0,0,1,0,2.47Zm-4-1.11L12.16,12l-1.35,1.64L10,9.42A7.12,7.12,0,0,1,11.65,7.82ZM9.39,10.33l.81,4.05-1.64,2A10,10,0,0,1,9.39,10.33Zm1.35,4.57,4.24.18C13.15,16.65,10.34,16.93,9,17Zm5-.69-.11.15-4.34-.18L13,12.12l3.74.31A8.17,8.17,0,0,1,15.78,14.21Z"
});

function SvgVegetarian(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    fill: "currentColor",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.91 24.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetarian);
export default __webpack_public_path__ + "static/media/Vegetarian.a1b8b697.svg";
export { ForwardRef as ReactComponent };